// extracted by mini-css-extract-plugin
export default {"home":"index_home__-62cW","content":"index_content__tsSsk","top":"index_top__uUYN1","table":"index_table__pdp0Z"};